export function SupplySku({ sku, className = "", ...props }) {
    const displayValue = sku == null || String(sku).trim() === "" ? "—" : sku;
    return (
        <span {...props} className={`text-sm font-semibold text-gray-900 whitespace-nowrap ${className}`.trim()}>
            {displayValue}
        </span>
    );
}

export default SupplySku;
